import { createContext } from 'react';
import type { ITabsContext } from '../types/ITab';

/** Индекс открытой вкладки ближайших Tabs: содержимое вкладок реагирует на её смену (отложенный маунт таблиц и т. п.). */
export const TabsContext = createContext<ITabsContext>({ activeTab: 0 });
